import React from 'react';
const painPoints = ['El lunes a las 8:50 todavía no sabés qué actividad vas a hacer en la sesión de las 9. Y eso se nota.', 'Tus pacientes llevan meses en tratamiento pero no podés mostrar una progresión clara por etapa ni por área de desarrollo.', 'Una familia te pregunta "¿cómo va mi hijo?" y lo único que podés dar es una respuesta vaga. Sin informe, sin datos, sin respaldo.', 'El domingo a las 23:00 seguís en Pinterest buscando actividades que no tienen criterio clínico ni secuencia terapéutica real.', 'Sabés que deberías cobrar más, pero no tenés un sistema profesional visible que justifique ese aumento frente a las familias.', 'Cada sesión empieza desde cero. Sin progresión, sin objetivo medible, sin fundamento. Y lo peor: ya te acostumbraste.'];
export function PainPoints() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(254, 242, 242)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-175">
      <div className="mx-auto max-w-3xl" data-id="element-176">

        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-177">
          ¿Te sentís identificada?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-178">
          Esto le pasa al 90% de las profesionales
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-179">
          No es falta de conocimiento. Es falta de un sistema.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-180">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-181">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-182">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-183">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-cyan-brand m-0 mb-6" data-id="element-184">
          ¿Cuántas sesiones más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(0, 180, 216), rgba(255, 255, 255, 0))'
      }} data-id="element-185" />
      </div>
    </section>;
}